<template>
  <div>
    <b-row class="justify-content-md-center align-items-center text-center">
      Sales data prior to <strong class="mx-1">{{lastResetDate}}</strong> has been generated using BOM setups from <strong class="mx-1">{{lastResetDate}}</strong>
    </b-row>
    <b-row class="justify-content-md-center align-items-center text-center">
      Sales data after <strong class="mx-1">{{earliestSoDate}}</strong> may not be complete as there are open SOs after then.
    </b-row>
    <b-row class="justify-content-md-center align-items-center text-center" style="color: red;">
      The child items listed include their parents' sale data
    </b-row>
    <b-row class="justify-content-md-center align-items-center text-center" style="color: red;">
      This page doesn't search for KITs, if you want info on a KIT, search for its items
    </b-row>
    <hr />
    <b-alert show v-if=kit variant=warning>This item is a kit, please search for a kit item instead</b-alert>
    <b-alert show v-else-if=!hasResults variant=danger>There were no results found, make sure you're using the right item num</b-alert>
  </div>
</template>

<script>
export default {
  props: {
    lastResetDate: String,
    earliestSoDate: String,
    kit: Boolean,
    hasResults: Boolean,
  }
}
</script>



// WEBPACK FOOTER //
// src/components/purchasing/SalesNotes.vue